import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { FuseConfigService } from '@theme/services/config.service';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserTypes } from 'src/app/config/user-types';
import { monthlyViewType } from '../../config/monthly-view-type';
import { ManageUsersAccountService } from '../manage-users-account.service';

@Injectable(
  { providedIn: 'root' }
)
export class FacilityAuthGuard  {
  constructor(
    public _deviceService: DeviceDetectorService,
    private fuseConfigService: FuseConfigService,
    private cookieService: CookieService,
    private router: Router,
    private authenticationService: ManageUsersAccountService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationService.currentUserSubject.pipe(
      map(e => {
        if (!!e) {
          switch (e.activeusertype.usertypeid) {
            case UserTypes.Scheduler:
            case UserTypes.HubUser:
              if (!this.cookieService.get('IntelycareAuthCookie')) {
                this.authenticationService.clearLocalStorage();
                e = null;
              }

              if (this.authenticationService.facilityType === monthlyViewType.intelypro) {
                if (this._isSmallDevice() && state.url !== '/redirect') {
                  if (this.router.url === '/facility/login') {
                    this.router.navigateByUrl('/redirect');
                    return false;
                  }
                }
                return true;
              }
          }
        }
      })
    );
  }

  private _isSmallDevice(): boolean {
    const iFrameDetection = (window === window.parent) ? false : true;
    return this._deviceService.isMobile() || iFrameDetection;
  }
}
